module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-MediumItalic.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-MediumItalic.eot
// module id = 1905
// module chunks = 0